import type { JerseySize } from './Jersey.types';
import { getJerseyDimensions } from './getJerseyDimensions';

export function EmptyJersey({
  size,
  is32WithIconLayout,
}: {
  size: JerseySize;
  is32WithIconLayout: boolean;
}) {
  const { width: jerseyW, height: jerseyH } = getJerseyDimensions(size);

  return (
    <div
      className={`${is32WithIconLayout ? 'absolute left-0 top-0' : 'relative w-full h-full'} bg-monoY dark:bg-pmw-eb-primary-dark rounded-[4px]`}
      style={{ width: jerseyW, height: jerseyH }}
      aria-hidden
    />
  );
}
